import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { changeSearchTerm, changeSortBy } from "../../features/filters/filtersSlice";

const JobNav = () => {
  const dispatch = useDispatch();
  

  
  return (
    <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
      <h1 className="lws-section-title">All Available Jobs</h1>
      <div className="flex gap-4">
        <div className="search-field group flex-1">
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
          <input
            type="text"
            placeholder="Search Job"
            className="search-input"
            id="lws-searchJob"
            onChange={(e) => dispatch(changeSearchTerm(e.target.value))}
          />
        </div>
        <select
          id="lws-sort"
          name="sort"
          autoComplete="sort"
          className="flex-1"
          onChange={(e) => dispatch(changeSortBy(e.target.value))}
        >
          <option>Default</option>
          <option>Salary (Low to High)</option>
          <option>Salary (High to Low)</option>
        </select>
      </div>
    </div>
  );
};

export default JobNav;
